module.exports = __webpack_public_path__ + "c5d20e13e99488b1c195ff285cd59b63.png";